import { Component, computed, input } from '@angular/core';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {
  faPen,
  faThumbtack,
  faThumbtackSlash,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { NgClass } from '@angular/common';

type ActionPart = {
  type: 'action';
  name: () => string;
  icon: () => IconProp;
  style: string;
};

type SeparatorPart = { type: 'separator' };

type Part = ActionPart | SeparatorPart;

@Component({
  selector: 'app-flowpilot-chat-action',
  imports: [FaIconComponent, NgClass],
  template: `
    <div class="flex size-full flex-col gap-y-2">
      @for (part of parts; track part) {
        @if (part.type === 'separator') {
          <h1 class="border-dune-300 dark:border-dune-700 w-full border"></h1>
        } @else if (part.type === 'action') {
          <div
            class="hover:bg-dune-100 dark:hover:bg-dune-1000 flex w-32 cursor-pointer gap-x-1.5 rounded-lg px-1.5 py-1">
            <fa-icon [ngClass]="getColor(part.style!)" [icon]="part.icon!()" />

            <span [ngClass]="getColor(part.style!)">{{ part.name!() }}</span>
          </div>
        }
      }
    </div>
  `,
})
export class FlowpilotChatActionComponent {
  /** INPUTS **/
  /****/
  readonly pinned = input<boolean>(false);

  /** PROPERTIES **/
  /****/
  protected readonly parts: Part[] = [
    {
      name: computed(() => (this.pinned() ? 'Unpin' : 'Pin')),
      icon: computed(
        () =>
          (this.pinned()
            ? ['fas', 'thumbtack-slash']
            : ['fas', 'thumbtack']) as IconProp
      ),
      type: 'action',
      style: 'default',
    },
    {
      name: () => 'Rename',
      icon: () => ['fas', 'pen'] as IconProp,
      type: 'action',
      style: 'default',
    },
    {
      type: 'separator',
    },
    {
      name: () => 'Delete',
      icon: () => ['fas', 'trash'] as IconProp,
      type: 'action',
      style: 'delete',
    },
  ];

  constructor(library: FaIconLibrary) {
    library.addIcons(faThumbtack, faThumbtackSlash, faPen, faTrash);
  }

  protected getColor(variant: string) {
    return {
      'text-dune-700 dark:text-dune-300': variant === 'default',
      'text-torch-500': variant === 'delete',
    };
  }
}
